import * as $ from 'jquery';
import * as _ from 'underscore';
import {PanotestComponent} from './panotest.component';
import MyClass from './MyClass';
import * as THREE from 'three';
import Scenes from './Scenes';
import {PanotestService} from './panotest.service';

export default class UserInterface {
  debug = false;
  debugStats = false;
  debugComms = false;


  userName: string;
  //currentScene: null;   //the current scene in view
  sceneReady: boolean = false;
  widgets = [];      //an array fo widgets created for this scene. deleted when moving to another scene.
  spots = [];
  bigLabel: {
    title: string,
    desc: string,
    text: string
  };

  audioPromptPlayer: HTMLAudioElement = new Audio();
  sysAudioPlayer: HTMLAudioElement = new Audio();
  sysAudioPlayerCallback;
  sysAudioPlayerUrl;
  sysAudioPlayerPlaying = false;
  userMission = '';
  missionIcon = '';
  heroText: '';
  showUserInfo = false;
  assignedButtonLabel: string;
  ray = {x: 0, y: 0, z: 0};
  lookAt = {x: 0, y: 0, z: 100};
  initialCamCoords = null
  lookAtTarget: any;
  target = {x: 0, y: 0, z: 0};
  hoverObject: any;
  viewController: null;
  fov: null;
  pan: null;
  panTimer: any;
  rotationF: 0;
  videoPlayerURL: '';
  audioImg: '';
  audioPrompt: '';
  videoPlayerHandle: HTMLVideoElement;
  showVideoPlayer: boolean = false;
  showImageViewer: boolean = false;
  showAudioPlayer: boolean = false;
  showHtmlPopup: boolean = false;
  showQuiz1: boolean = false;
  showQuiz2: boolean = false;
  showQuiz3: boolean = false;
  showQuiz4: boolean = false;
  showQuiz5: boolean = false;
  showQuiz6: boolean = false;
  showQuiz7: boolean = false;
  showQuiz8: boolean = false;
  showQuiz9: boolean = false;
  showQuiz10: boolean = false;
  showQuiz11: boolean = false;
  showQuiz12: boolean = false;
  showQuiz13: boolean = false;

  htmlPopupId = 0;

  //Quizzes
  setQuizChoices = 0;
  setQuizChoice2 = 0;
  clockIdx = 1;
  quizFeedback ="";

  audioTitle = '';
  audioDesc = '';
  audioHtml = '';

  immiImgIdx = 0;

  camera = {
    rotation: {x: 0, y: 0, z: 0},
    position: {x: 0, y: 0, z: 0}
  };
  camToSave = {
    position: {x: 0, y: 0, z: 0},
    rotation: {x: 0, y: 0, z: 0},
    controlCenter: null
  };
  icons = {
    map: 'assets/images/acu/map1-lighter.png',
    quiz: 'assets/images/acu/quiz-lighter.png',
    door: 'assets/images/btn-door.png',
    video: 'assets/images/acu/video-lighter.png',
    light: 'assets/images/btn-new-light-up.png',
    read: 'assets/images/acu/read-lighter.png',
    listen: 'assets/images/acu/listen-lighter.png'


  };
  toolbar = {
    map: 'assets/images/acu/map1-lighter.png',
    quiz: 'assets/images/acu/quiz-lighter.png',
    door: 'assets/images/btn-door.png',
    video: 'assets/images/acu/video-lighter.png',
    light: 'assets/images/btn-new-light-up.png',
    read: 'assets/images/acu/read-lighter.png',
    listen: 'assets/images/acu/listen-lighter.png',

  };


  SCOPE: PanotestComponent;
  SCENES: Scenes;
  GAME: MyClass;
  panoservice: PanotestService;
  raycaster = {};

  constructor(panoservice: PanotestService) {
    console.log('UI');
    //if(this.getUrlVars()["debug"]) this.debug = true;
    this.panoservice = panoservice;
    this.SCOPE = panoservice.scope;
    this.SCENES = panoservice.scenes;
    this.GAME = panoservice.game;
    this.bigLabel = {
      title: '',
        desc: '',
        text: ''
    };


  }

  imgUrlBuilder(){
    return 'url('+ this.audioImg + ')';
  }
  clockSubmit(){
    this.clockIdx++;
    this.quizFeedback = '';
    this.setQuizChoices = 0;
    //play next audio
    if(this.clockIdx==2) {
      this.playAudioViaButton('./assets/audio/0005-acu-audio-5.mp3');
      this.showQuizChoices(2);
    }
    if(this.clockIdx==3) {
      this.playAudioViaButton('./assets/audio/0006-acu-audio-6.mp3');
      this.showQuizChoices(3);
    }

  }
  showQuizChoices(idx){
    this.setQuizChoices = idx;

  }
  /*matchItems(choice, expected){
    if(this.setQuizChoice === expected){
      //correct
      this.quizFeedback =" Well done!"
      this.clockIdx++
    }else{
      //incorrect
      this.quizFeedback =" Not quite! Try again."
    }
  }*/

  playVideo(url) {
    this.videoPlayerURL = url;
    this.panoservice.game.closeAllPanels();
    this.showVideoPlayer = true;
    window.setTimeout(() => { this.setVideo()}, 500);
  }

  stopAllAudio(){
    this.sysAudioPlayer.pause();
    this.audioPromptPlayer.pause();
    this.audioPromptPlayer.removeEventListener('ended',this.sysAudioPlayerCallback)
    this.audioPrompt = '';
    this.sysAudioPlayerPlaying = false;
    this.sysAudioPlayer.pause()
    this.sysAudioPlayer.src = '';

  }

  pauseAudioPlayer(){
    console.log('Pause audio player');
    let el: any = document.getElementById('audioPlayerIframe');
    if(el) el.pause();

  }
  replayAudioPlayer(){
    console.log('Replay audio player');
    let el: any = document.getElementById('audioPlayerIframe');
        el.setAttribute('src', this.videoPlayerURL);
  }

  replayAudioPrompt(){
    console.log('Replay audio prompt')
    this.sysAudioPlayer.pause();
    this.audioPromptPlayer.pause();
    this.audioPromptPlayer.src = this.audioPrompt;
    this.audioPromptPlayer.play();

  }

  pauseAudioPrompt(){
    this.audioPromptPlayer.pause();
  }
  unpauseAudioPrompt(){
    this.audioPromptPlayer.play();
  }

  playAudioPrompt(url){
    this.audioPromptPlayer.pause();
    this.audioPrompt = url;
    this.audioPromptPlayer.src = url;
    this.audioPromptPlayer.play();
    this.sysAudioPlayerPlaying = false;
    this.audioPromptPlayer.addEventListener('ended', ()=>{
      console.log('Audio Prompt Audio Ended');
      if(this.audioPrompt.indexOf('0023-acu-audio-23.mp3') != -1){
        //patch to chain audio..
        this.playAudioViaButton('./assets/audio/0004-acu-audio-4.mp3');
        this.showQuizChoices(1);
      }
    });
  }

  playAudioViaButton(url, callback=null){
    this.sysAudioPlayerPlaying = false;
    this.audioPromptPlayer.pause();
    this.sysAudioPlayer.removeEventListener('ended', this.sysAudioPlayerCallback);
    this.sysAudioPlayer.pause();
    this.sysAudioPlayer.src = this.sysAudioPlayerUrl = url;
    if(callback) {
      this.sysAudioPlayerCallback = callback;
      this.sysAudioPlayer.addEventListener('ended', () => {
        this.sysAudioPlayerCallback();
        this.sysAudioPlayerPlaying=false;
      });
    }
    this.sysAudioPlayer.play();
    this.sysAudioPlayerPlaying = true;
  }
  pauseSystemAudio(){
    this.sysAudioPlayer.pause()
  }
  unpauseSystemAudio(){
    this.sysAudioPlayer.play()
  }
  replaySystemAudio(){
    this.sysAudioPlayer.pause();
    this.sysAudioPlayer.src = this.sysAudioPlayerUrl;
    this.sysAudioPlayer.play();


  }

  q4AudioDone = false;
  q4AudioComplete(){
    return () => {
      console.log('Audio completed');
      this.q4AudioDone = true;
      this.sysAudioPlayer.removeEventListener('ended', this.sysAudioPlayerCallback);
    };
  }

  msgTimeOut: any;
  setUserMission(i: Action) {



    console.log('UI.setUserMission '+i.mission)
    if(i.mission === this.userMission) return

    let scope = this;

    this.showUserInfo = false;
    clearTimeout(this.msgTimeOut);

    //let elem = document.getElementById('tip');
    //$(elem).hide();

    if(i.mission == '') {
      this.userMission = '';
      this.clearUserMission();
      return
    }else{
      this.userMission = i.mission;
    }

    this.missionIcon = i.missionIcon || '';

    const delay =  i.missionTimer || 3000;

    this.msgTimeOut = window.setTimeout(function(){
      console.log('showUserInfo [TIMER] ');
      //Is it already done
      //this.userMission = msg;

      scope.showUserInfo = true;

     /* let elem = document.getElementById('sceneInfo');
      $(elem).addClass('animated slideInUp');
      $(elem).show();

      elem.addEventListener('animationend', function () {
        $(this).removeClass('animated slideInUp');
        this.removeEventListener('animationend', this);
      });*/


    }, delay);


  }
  clearUserMission(){
    this.showUserInfo = false;
    clearTimeout(this.msgTimeOut);

  }
  showUserMission(msg) {
    console.log('showUserMission Animation ')
    let elem = document.getElementById('tip');
        $(elem).addClass('animated slideInUp');
        $(elem).show();
          /*elem.addEventListener('animationend', function () {
            $(this).removeClass('animated slideInUp');
            this.removeEventListener('animationend', this);
          });*/
  }

  showMap(){
    console.log('SetupHover anims');

    window.setTimeout(function(){
      console.log($('.menu .menuPin'))
      $('.menu .menuPin').mouseenter(function(){
        console.log('PIN HOVER');
        $(this).find('.pinMenu').addClass('animated bounce');
      })

      $('.menu .menuPin').mouseleave(function(){
        $(this).find('.pinMenu').removeClass('animated bounce');
      })

    },500)



  }
  panCamera(scp){

    try {
      scp.OrbitControls.rotateLeft(0.0002);
    }
    catch(e){

    }

  }

  clearWidgets() {
    console.log('----------Clear widgets-----------')
    for (let w = 0; w < this.widgets.length; w++) {

      const el = this.widgets[w];
      //const spot =  this.focusObj;
      //console.log(el);
      //if(spot) spot.dispose();

      el.dispose();
      $(el).remove();

    }
  }
  clearSpots() {
    for (let w = 0; w < this.spots.length; w++) {

      const el = this.spots[w]
      el.dispose();
      $(el).remove();

    }
  }
  enableWidget(spotName: string){

    this.SCENES.enableWidget(spotName);

  }
  completedWidget(i: Action){

    if(i.infoSpotId) {
      //find a widget that matches
      const widget = this.panoservice.scenes.findWidgetBySpotId(i.infoSpotId);
      if(widget){
        console.log('Found matching widget...' + i.infoSpotId);
        let elem = $('#' + widget.style.id)
        elem.css({opacity: 1});
        elem.removeClass('animated bounce delay-1');
        elem.addClass('desaturate animated flipInY delay-1');

        if(elem.find('.widgetTick').length == 0) {
          let oImg = document.createElement("img");
          oImg.setAttribute('src', 'assets/images/icn-tick.png');
          oImg.setAttribute('alt', 'na');
          oImg.setAttribute('height', '18px');
          oImg.setAttribute('width', '18px');
          oImg.style.position='absolute';
          oImg.style.right='-5px';
          oImg.style.top='50px';
          $(oImg).addClass('widgetTick');
          document.getElementById(widget.style.id).appendChild(oImg);
        }

      }
    }else{
      console.log('interaction has no infoSpotId. Cant animate')
    }


  }
  highlightCurrentWidget(){

    const widget = this.panoservice.scenes.findWidgetBySpotId(this.panoservice.game.currentInteraction.infoSpotId);
    if(widget){
      const elem = document.getElementById(widget.style.id);
      if(elem){
        $(elem).addClass('animated bounce delay-1');
        elem.addEventListener('animationend', function() {
          $(this).removeClass('animated bounce delay-1');
        });
      }else{
        console.log('Widget Element not found for highlight ', widget);
      }

    }else{
      console.log('Widget via SpotId not found', this.panoservice.game.currentInteraction.infoSpotId);
    }
  }
  resetInitalCameraCoords(){
    this.initialCamCoords = null;
  }
  setCameraCoords(x, y, z) {

    this.camera.rotation.x = x;
    this.camera.rotation.y = y || this.camera.rotation.y;
    this.camera.rotation.z = z || this.camera.rotation.z;

    if (this.initialCamCoords == null) {

      this.initialCamCoords = {x: this.camera.rotation.x, y: this.camera.rotation.y, z: this.camera.rotation.z};

    }
    //console.log(x)
  }
  setTarget(x: number, y: number, z: number) {
    this.target.x = x;
    this.target.y = y;
    this.target.z = z;

  }
  lookAtNow(v: number) {
    console.log("LookAtUpdate");
    this.lookAt.x += v;

    this.SCOPE.viewer.tweenControlCenter(new THREE.Vector3(this.lookAt.x, this.lookAt.y, this.lookAt.z), 1);

  }
  lookAtNowY(v: number) {
    console.log("LookAtUpdate");
    this.lookAt.y += v
    console.log(this.SCOPE.viewer.control.target);
    this.SCOPE.viewer.tweenControlCenter(new THREE.Vector3(this.lookAt.x, this.lookAt.y, this.lookAt.z), 1);
    console.log(this.lookAt);
  }
  lookAtNowZ(v: number) {
    console.log("LookAtUpdate");
    this.lookAt.z += v
    console.log(this.SCOPE.viewer.control.target);
    this.SCOPE.viewer.tweenControlCenter(new THREE.Vector3(this.lookAt.x, this.lookAt.y, this.lookAt.z), 1);
    console.log(this.lookAt);
  }
  lookAtNowAnim(obj, d: number = 0) {
    console.log('lookAtNowAnim')

    if (obj != null) {
      this.SCOPE.viewer.tweenControlCenter(new THREE.Vector3(obj.position.x, obj.position.y, obj.position.z), d);
    } else {
      console.log('No Look At Target')
    }
  }
  rotate() {
    this.SCOPE.viewer.control.rotate(this.rotationF * Math.PI / 180);
  }
  storeCamera() {

    this.camToSave.position = this.SCOPE.viewer.camera.position.clone();
    this.camToSave.rotation = this.SCOPE.viewer.camera.rotation.clone();
    this.camToSave.controlCenter = this.SCOPE.viewer.control.center.clone();
  }
  restoreCamera() {

    this.SCOPE.viewer.control.reset();
    this.SCOPE.viewer.camera.position.set(this.camToSave.position.x, this.camToSave.position.y, this.camToSave.position.z);
    this.SCOPE.viewer.camera.rotation.set(this.camToSave.rotation.x, this.camToSave.rotation.y, this.camToSave.rotation.z);

    this.SCOPE.viewer.control.center.set(this.camToSave.controlCenter.x, this.camToSave.controlCenter.y, this.camToSave.controlCenter.z);
    this.SCOPE.viewer.update();

    //render();

  }
  setVideo() {
    console.log('Init Video Player ' + this.videoPlayerURL);

    const video: any = document.getElementById('vid1');
    console.log(video);
    if (video) {
       video.setAttribute("src", this.videoPlayerURL);
       video.play();
       this.videoPlayerHandle = video;
       this.videoPlayerHandle.addEventListener('ended', ()=> this.videoEnded());
    }


    window.setTimeout(function(){
      console.log('Set focus to Close button');
      if(this.showImageViewer == true) document.getElementById("popupClose");
      if(this.showVideoPlayer == true) document.getElementById("videoClose");
      if(this.showAudioPlayer == true) document.getElementById("videoClose");


    },1000);

  }
  videoEnded(){
    console.log('Video Ended');
    if(this.videoPlayerURL.indexOf('outside-classroom-4')!=-1){

      this.closeVideoPlayer();

    }else{
      $(this.videoPlayerHandle).addClass('animated fadeOut animate__delay-4s');
      this.videoPlayerHandle.addEventListener('animationend', () => {
        this.closeVideoPlayer();
      });
    }


  }

  closeVideoPlayer(): void {
    console.log('CLOSE VIDEO PLAYER. FADED DONE')
    this.showVideoPlayer = this.showAudioPlayer = false;
    this.videoPlayerHandle.removeEventListener('ended', this.videoEnded)
    if (this.panoservice.game.currentInteraction) {

      this.completeInteraction();

    }else{
      console.log('Closing video player but no current interaction');
    }

  }
  closePopup() {
    console.log('Close Popup');
    this.showImageViewer = false;
    this.showAudioPlayer = false;
    if (this.panoservice.game.currentInteraction) {
      this.completeInteraction();

    }

  }
  completeInteraction(){

    //we know the currentInteraction has been completed. If it has an associated spot lets find it.
    console.log('==============UI::Interaction Completed:::;');
    //this.completedWidget();
    this.panoservice.game.interactionCompleted();


  }
  showBlocker() {
    console.log('Show Blocker');
    const b = document.getElementById('blocker');
    $(b).show();
    //$(b).addClass('animated fadeIn');

    /*b.addEventListener('animationend', function () {
      $(this).removeClass('animated fadeIn');
      $(this).show();
      this.removeEventListener('animationend', this)
    });*/

  }
  hideBlocker() {
    console.log('Hide Blocker');

    /*setTimeout(function(){
      const b = document.getElementById('blocker');
      $(b).addClass('animated fadeOut delay-2');
      b.addEventListener('animationend', function () {
        $(this).hide();
        $(this).removeClass('animated fadeOut delay-2');
        this.removeEventListener('animationend', this)
      });

    },3000)*/
    const b = document.getElementById('blocker');
          $(b).hide();




  }

  heroElement: any;

  heroTextStart(){
    console.log('HeroText Start')
    this.heroElement = document.createElement('div');
    this.heroElement.id = "sceneTitle";
    this.heroElement.innerHTML = this.heroText;

    document.getElementById('viewer').append(this.heroElement);

    $(this.heroElement).show();
    $(this.heroElement).addClass('animated fadeIn delay-2s')
    const elem = this.heroElement;

    this.heroElement.addEventListener('click', (ev: Event) => {
      this.heroElement.parentNode.removeChild(this.heroElement);
      this.panoservice.game.interactionCompleted();
    });

    this.heroElement.addEventListener('animationend',(ev: Event) => {
        let el = ev.target;
        $(el).removeClass('animated fadeIn delay-2s');
        $(el)[0].removeEventListener('animationend', this);
        this.heroEnd();

      } );

  }

  heroEnd(){

    const elem = this.heroElement;
    $(this.heroElement).addClass('animated fadeOut delay-4s');
    this.heroElement.addEventListener('animationend', () => {
        this.heroElement.parentNode.removeChild(this.heroElement);
        this.panoservice.game.interactionCompleted();
      });

  }

  killHero(){
    if(this.heroElement && this.heroElement.parentNode) this.heroElement.parentNode.removeChild(this.heroElement);
  }

  hideAllQuiz(){
    this.showQuiz1 = this.showQuiz2 = this.showQuiz3 = this.showQuiz4 = false;
    this.showQuiz5 = this.showQuiz6 = this.showQuiz7 = this.showQuiz8 = false;
    this.showQuiz9 = this.showQuiz10 = this.showQuiz11 = this.showQuiz12 = this.showQuiz13 = false;

  }



}
